import "./style.css"
import backgroundVideo from "../../assets/images/backgroundProducts.mp4";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { img17, img18, img19, img20, img21 } from "../../assets/images/meesaq"

const meesaqDetails = {
    name: "Meesaq (Environmental, Social, and Governance)",
    description: "This ESG management system is a comprehensive solution for organizations to streamline sustainability reporting, stakeholder analysis, material topic management, and impact assessment while aligning with SDGs. It includes modules for entity information, organization governance, budgeting, and reporting on environmental and social components such as waste, energy, and diversity. Users can manage activities, assess positive and negative impacts, track compliance, and generate detailed ESG and sustainability reports. The system also offers setups for defining data parameters, roles, and access management, ensuring seamless reporting and effective ESG",
    images: [img17, img18, img19, img20, img21],
}

const EnvironmentSocialAndGovernance = () => {
    const settings = {
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "60px",
        slidesToShow: 1,
        speed: 500
      };
    
    return (
        <div className="w-full relative h-full">
      {/* Background Section */}
      <section id="heading" className="relative flex">
        {/* Background Video */}
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src={backgroundVideo}
          autoPlay
          loop
          muted
          style={{ opacity: "0.25" }}
        />

        {/* Heading Content */}
        <div className="relative max-w-7xl mx-auto flex flex-col items-center justify-center h-screen z-10">
          <h1 className="text-4xl lg:text-5xl font-bold text-center text-white">
            <span className="gradient-headings">{meesaqDetails.name}</span>
          </h1>
          <p className="text-xl lg:text-2xl text-white mt-6 mx-auto max-w-4xl px-4 text-justify md:text-center">
          This <span className="font-bold">ESG management system</span> is a comprehensive solution for organizations to streamline sustainability reporting, stakeholder analysis, material topic management, and impact assessment while aligning with SDGs.
          </p>
        </div>
      </section>

      {/* Description Section */}
      <section className="pb-10 px-4 md:px-8 bg-gradient-to-r from-slate-950/80 via-slate-950/90 to-slate-950/100">
        <div className="container mx-auto flex flex-col-reverse md:flex-col   gap-10 xl:gap-16 items-center">
          <div className="text-base lg:text-xl text-white px-4 xl:mt-24">
            <p className="text-justify">{meesaqDetails.description}.</p>
          </div>
          <div className="w-full px-4 slider-container">
            <Slider {...settings}>
              {meesaqDetails.images.map((image, index) => (
                <div key={index} className="">
                  <img
                    src={image}
                    alt="product images"
                    className="w-full h-auto rounded-lg shadow-lg object-cover"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>


      
    </div>
    )
}

export default EnvironmentSocialAndGovernance